import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export const sliders = () => {
  const sliderTechnology = document.querySelector('.process .steps-mobile');
  if (sliderTechnology) {
    new Swiper(sliderTechnology, {
      slidesPerView: 1.6,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        992: {
          enabled: false,
        }
      }
    });
  }

  const sliderTechnology2 = document.querySelector('.process-2 .steps-mobile');
  if (sliderTechnology2) {
    new Swiper(sliderTechnology2, {
      slidesPerView: 1.6,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        992: {
          enabled: false,
        }
      }
    });
  }

  const sliderTechnology3 = document.querySelector('.process-2 .steps-small-mobile');
  if (sliderTechnology3) {
    new Swiper(sliderTechnology3, {
      slidesPerView: 1.6,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        992: {
          enabled: false,
        }
      }
    });
  }

  const sliderResarch = document.querySelector('.research-1 .research__wrapper');
  if (sliderResarch) {
    const nextBtn = sliderResarch.querySelector('.swiper-button-next');
    const prevBtn = sliderResarch.querySelector('.swiper-button-prev');

    new Swiper(sliderResarch, {
      modules: [Navigation],
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      slidesPerView: 1.2,
      spaceBetween: 25,
      breakpoints: {
        992: {
          slidesPerView: 4
        }
      }
    });
  }
  const sliderResarch2 = document.querySelector('.research-2 .research__wrapper');
  if (sliderResarch2) {
    const nextBtn = sliderResarch2.querySelector('.swiper-button-next');
    const prevBtn = sliderResarch2.querySelector('.swiper-button-prev');
    const navigationWrap = sliderResarch2.querySelector('.swiper-navigation');

    const swiperResearch2 = new Swiper(sliderResarch2, {
      modules: [Navigation],
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      slidesPerView: 1.2,
      spaceBetween: 25,
      breakpoints: {
        992: {
          slidesPerView: 4
        }
      }
    });

    const toggleResearch2Navigation = () => {
      if (!navigationWrap) return;
      navigationWrap.classList.toggle('swiper-navigation--hidden', swiperResearch2.isLocked);
    };

    swiperResearch2.on('lock', toggleResearch2Navigation);
    swiperResearch2.on('unlock', toggleResearch2Navigation);
    swiperResearch2.on('breakpoint', toggleResearch2Navigation);
    swiperResearch2.on('resize', toggleResearch2Navigation);
    swiperResearch2.on('update', toggleResearch2Navigation);
    toggleResearch2Navigation();
  }
  const reviewsWrap = document.querySelector('.reviews');
  const sliderReviews = document.querySelector('.reviews .reviews__wrapper');
  if (sliderReviews) {
    const nextBtn = reviewsWrap.querySelector('.swiper-button-next');
    const prevBtn = reviewsWrap.querySelector('.swiper-button-prev');

    new Swiper(sliderReviews, {
      modules: [Navigation],
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },

      spaceBetween: 25,
      breakpoints: {
        992: {
          slidesPerView: 1
        }
      }
    });
  }


  const sliderRecent = document.querySelector('.single-post .other__swiper');
  if (sliderRecent) {
    const nextBtn = sliderRecent.querySelector('.swiper-button-next');
    const prevBtn = sliderRecent.querySelector('.swiper-button-prev');

    new Swiper(sliderRecent, {
      modules: [Navigation],
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      slidesPerView: 1.3,
      spaceBetween: 24,

    });
  }
};